import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const SfFigureStandIcon = props => /*#__PURE__*/_jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ...props,
  children: /*#__PURE__*/_jsx("path", {
    fill: "currentColor",
    d: "M7 14.394c0 .511.4.913.911.913a.903.903 0 0 0 .905-.913V10.59c0-.169.142-.302.31-.302a.3.3 0 0 1 .304.302v11.545c0 .553.447.993 1.001.993.55 0 1.001-.441 1.001-.993v-7.03a.32.32 0 0 1 .31-.317c.17 0 .318.149.318.317v7.03a.99.99 0 0 0 .995.993.993.993 0 0 0 1-.993V10.589c0-.169.132-.302.303-.302.168 0 .31.133.31.302v3.805c0 .511.402.913.905.913a.903.903 0 0 0 .911-.913v-4.25c0-2.204-1.64-3.661-4.013-3.661h-1.459C8.64 6.483 7 7.94 7 10.144v4.25Zm4.742-9.015c1.213 0 2.19-.975 2.19-2.189 0-1.213-.977-2.19-2.19-2.19s-2.19.977-2.19 2.19c0 1.214.977 2.19 2.19 2.19Z"
  })
});
export default SfFigureStandIcon;